import { Component, Input } from '@angular/core';

@Component({
  selector: 'sso-section-fields',
  template: `
    <text *ngIf="useSSO" key="USE_SSO"></text>
    <text *ngIf="!useSSO" key="NOT_USE_SSO"></text>
    <text key="MORE_INFO_SSO"></text>
    <div><faq-popup faqCode="SSO"><text key="FAQ_584"></text></faq-popup></div>
    <div><faq-popup faqCode="USER_REGISTRATION_SSO"><text key="FAQ_642"></text></faq-popup></div>
	`
})
export class SSOSectionFieldsComponent {
  @Input() public useSSO:boolean;
}